"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipRateBlank = exports.MembershipRateRequestDTOSchema = exports.MembershipRateDTO = exports.MembershipRateDTOSchema = exports.MembershipRateSchema = exports.MembershipRateBaseSchema = exports.CURRENCY_NAMES = exports.RATE_FREQUENCY_MAP = exports.RATE_FREQUENCY = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var RATE_FREQUENCY;
(function (RATE_FREQUENCY) {
    RATE_FREQUENCY["MONTH"] = "month";
    RATE_FREQUENCY["YEAR"] = "year";
})(RATE_FREQUENCY || (exports.RATE_FREQUENCY = RATE_FREQUENCY = {}));
exports.RATE_FREQUENCY_MAP = (_a = {},
    _a[RATE_FREQUENCY.MONTH] = 'monthly',
    _a[RATE_FREQUENCY.YEAR] = 'yearly',
    _a);
// A simple implementation for displaying a currency text.
exports.CURRENCY_NAMES = {
    EUR: 'euros',
    USD: 'dollars',
    // Add more currencies if needed.
};
exports.MembershipRateBaseSchema = zod_1.z.object({
    Type: zod_1.z.string().min(2, 'The Type must contain at least 2 letters'),
    // TypeSlug: Used to group rates of the same membership type (e.g., "full-member", "basic-member")
    // All rates with different durations of the same type should share the same TypeSlug
    TypeSlug: zod_1.z
        .string()
        .min(2, 'TypeSlug must be at least 2 characters')
        .regex(/^[a-z0-9-]+$/, 'TypeSlug must be lowercase letters, numbers, and hyphens only')
        .optional(),
    Rate: zod_1.z.coerce.number().min(1, { message: 'Rate should be greater or equal to 1' }),
    // Consider using an ENUM if mongoose-zod allows it.
    RateCurrency: zod_1.z
        .string()
        .min(1, { message: 'The currency of the rate cannot be empty' })
        .max(3, { message: 'The currency of the rate can not be greater than 3 letters' }),
    // StripeProductId: the Stripe price ID (e.g. "price_xxx") this rate is billed against.
    // Optional/blank for rates that are not managed through Stripe (e.g. Honorary Member, Non-Member).
    StripeProductId: zod_1.z.string().optional(),
    IsActive: zod_1.z.boolean().default(false),
    ShowInFilter: zod_1.z.boolean().default(false),
    // IsPYAMember: Indicates if this membership type represents a PYA-considered member
    // Used for filtering in dashboards and statistics (excludes Non-Members, Partners, etc.)
    IsPYAMember: zod_1.z.boolean().default(true),
    // AvailableForSelection: Controls whether this rate appears in signup/upgrade flows
    // Set to false for admin-only rates like Honorary Member
    AvailableForSelection: zod_1.z.boolean().default(true),
    /** When true, members on this rate can access Forums (if the global forums flag is on). */
    ForumsAccess: zod_1.z.boolean().default(false),
    BrevoTemplateId: zod_1.z.coerce.number().optional(),
    // New fields for duration support
    Duration: zod_1.z.coerce.number().min(1, { message: 'Duration must be at least 1' }).default(1),
    DurationUnit: zod_1.z.nativeEnum(RATE_FREQUENCY).default(RATE_FREQUENCY.YEAR),
});
exports.MembershipRateSchema = exports.MembershipRateBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.MembershipRateDTOSchema = exports.MembershipRateSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.MembershipRateDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Type: model.Type,
            TypeSlug: model.TypeSlug,
            Rate: model.Rate,
            RateCurrency: model.RateCurrency,
            StripeProductId: model.StripeProductId,
            IsActive: model.IsActive,
            ShowInFilter: model.ShowInFilter,
            IsPYAMember: model.IsPYAMember,
            AvailableForSelection: model.AvailableForSelection,
            ForumsAccess: model.ForumsAccess === true,
            BrevoTemplateId: model.BrevoTemplateId,
            Duration: model.Duration,
            DurationUnit: model.DurationUnit,
        };
        return dto;
    },
};
exports.MembershipRateRequestDTOSchema = exports.MembershipRateDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.MembershipRateBlank = {
    Type: '',
    TypeSlug: '',
    Rate: 1,
    RateCurrency: 'EUR',
    StripeProductId: '',
    IsActive: false,
    ShowInFilter: false,
    IsPYAMember: true,
    AvailableForSelection: true,
    ForumsAccess: false,
    Duration: 1,
    DurationUnit: RATE_FREQUENCY.YEAR,
};
//# sourceMappingURL=MembershipRate.js.map